import { PlatformLocation } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { LanguageDefinition, RegionDefinition } from '@shared/services/language/registry';
import { CurrentLanguage, resolveCurrentLanguage } from '@shared/services/language/resolve-current-language';

/** Resolved once per application, hence once per request on the server, from the host and the path. */
@Injectable({ providedIn: 'root' })
export class CurrentLanguageService {
  readonly region: RegionDefinition;
  readonly language: LanguageDefinition;
  private readonly location = inject(PlatformLocation);

  constructor() {
    const resolved = this.resolve(this.location.pathname);
    this.region = resolved.region;
    this.language = resolved.language;
  }

  /** Resolves any URL of this host, whose language may differ from the application's. */
  resolve(url: string): CurrentLanguage {
    return resolveCurrentLanguage(this.location.hostname, url, environment.domains);
  }
}
